import SignUpProgress from '@/components/auth/signup/Progress'
import AuthLayout from '@/components/auth/AuthLayout'
import { SignupProgressProvider } from '@/context/SignupProgressContext'
import { useNavigate, useSearchParams } from 'react-router'
import { useEffect } from 'react'
import SignupPersonalAuthentication from '@/components/auth/signup/PersonalAuthentication'

const SignUpPage = () => {
  return (
    <>
      <SignUpProgress />
      <SignupPersonalAuthentication />
    </>
  )
}

const SingupPageWrapper = () => {
  const navigate = useNavigate()
  const [searchParams] = useSearchParams()
  const token = searchParams.get('token')

  useEffect(() => {
    if (!token) {
      navigate('/auth/login')
    }
  }, [navigate, token])

  return (
    <SignupProgressProvider token={token ?? ''}>
      <AuthLayout headerButton="cancle">
        <SignUpPage />
      </AuthLayout>
    </SignupProgressProvider>
  )
}

export default SingupPageWrapper
